import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppConstants } from "../../Constants/AppConstants";
import { useUserRolePermission } from "../../Context/UserRolePermission/UserRolePermissionState";
import {
  getLoggedInUserDetailsAPI,
  getUserByRoleIdAPI,
  getUserDetailsAPI,
} from "../../Store/Action/UserAction";
import Strings from "../../Config/Strings";
import TopNavBar from "../../Components/TopNavbar";
import LeftSideNav from "../../Components/LeftSideNav";
import CustomTopView from "../../Components/CustomTopView";
import UserTable from "../Users/Component/UserTable";
import Colors from "../../theme/Colors";
import TransportTable from "./Component/TransportTable";
import { getTransportDetailsAPI } from "../../Store/Action/transportAction";

const TransportList = () => {
  const [transport, setTransport] = useState([]);
 
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userData } = useSelector((state) => state.user);
  const limit = AppConstants.limit;
  const rowsPerPageLabel = "User Per Page";

  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(1);
 
  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0);
  }, []);

  const onAddCustomers = useCallback(() => {
    navigate("/admin/transport/add-transport", { state: { addForm: true } });
  }, [navigate]);

  const onViewUsers = useCallback(
    (user) => {
      navigate(`/admin/userDetails/${user?.user_id}`, { state: { user } });
    },
    [navigate]
  );

  useEffect(() => {
    dispatch(getLoggedInUserDetailsAPI({}));
  }, [dispatch]);

  useEffect(() => {
    const transportAPI = async () => {
      try {
        const params = {
          searchQuery: searchQuery || undefined,
          page: pageNumber || undefined,
          limit: limit || undefined,
        };

        dispatch(
          getTransportDetailsAPI(params, (result) => {
          
            setTransport(result?.data || []);
            setTotalCount(result?.totalCount);

            if (searchInputRef.current) {
              searchInputRef.current.focus();
            }
          })
        );
      } catch (error) {
        console.log("Failed to fetch users:", error);
      }
    };
    transportAPI();
  }, [dispatch, limit, pageNumber, searchQuery]);

  const recordAfterSorting = transport?.slice(
    pageNumber * rowsPerPage,
    (pageNumber + 1) * rowsPerPage
  );

  useEffect(() => {
    setBreadcrumbs([{ key: "1", href: "/userList", text: "Customers" }]);
  }, [rowsPerPage]);

  const getTransportRefresh = () => {
    dispatch(
      getTransportDetailsAPI({}, (result) => {
        setTransport(result?.data || []);
        setTotalCount(result?.totalCount);

        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      })
    );
  };
  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />

      <div style={topContainerStyle}>
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.[0]?.user_first_name}`}
          isDashboard={true}
        />

        <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Transport"}
          exportButtonText={"Export Transport"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          onAddButtonClick={onAddCustomers}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />

        <div style={tableContainerStyle}>
          <TransportTable
            transportData={recordAfterSorting}
            totalItems={totalCount}
            rowsPerPage={rowsPerPage}
            getTransportRefresh={getTransportRefresh}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflow: "hidden",
};

const topContainerStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const tableContainerStyle = {
  // width: "fit-content",
  height: "100%",
  marginLeft: "25px",
  borderRadius: "10px",
  margin: 20,
};

export default TransportList;
